// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1MFwP","footer":"ModalError_footer__2a2lt"};